import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { publicRoutes, donorRoutes, ngoRoutes } from "./routePaths";
import { useSelector } from "react-redux";

const PrivateDonorRoute = () => {
  const { isAuthenticated, isDonor } = useSelector((state) => state.auth);
  if (isAuthenticated && isDonor) {
    return <Outlet />;
  }
  return <Navigate to="/auth/donor/login" replace />;
};

const PrivateNGORoute = () => {
  const { isAuthenticated, isNGO } = useSelector((state) => state.auth);
  if (isAuthenticated && isNGO) {
    return <Outlet />;
  }
  return <Navigate to="/auth/ngo/login" replace />;
};

const Routing = () => {
  return (
    <Routes>
      {donorRoutes.map((route, index) => {
        if (route.children) {
          const Children = () => {
            return (
              <Routes>
                {route?.children?.map((child, index) => {
                  return (
                    <Route key={`${index}-xxx`} element={<PrivateDonorRoute />}>
                      <Route
                        path={child.path}
                        key={`${index}-sss`}
                        index={child.index}
                        element={child.element}
                      />
                    </Route>
                  );
                })}
              </Routes>
            );
          };

          return (
            <Route
              key={`${index}-yyy`}
              path={route.path}
              element={<Children />}
            />
          );
        }

        return (
          <Route key={`${index}-xxx`} element={<PrivateDonorRoute />}>
            <Route
              key={Math.random()}
              path={route.path}
              element={route.element}
            />
          </Route>
        );
      })}

      {ngoRoutes.map((route, index) => {
        if (route.children) {
          const Children = () => {
            return (
              <Routes>
                {route?.children?.map((child, index) => {
                  return (
                    <Route key={`${index}-xxx`} element={<PrivateNGORoute />}>
                      <Route
                        path={child.path}
                        key={`${index}-sss`}
                        index={child.index}
                        element={child.element}
                      />
                    </Route>
                  );
                })}
              </Routes>
            );
          };

          return (
            <Route
              key={`${index}-yyy`}
              path={route.path}
              element={<Children />}
            />
          );
        }

        return (
          <Route key={`${index}-xxx`} element={<PrivateNGORoute />}>
            <Route
              key={Math.random()}
              path={route.path}
              element={route.element}
            />
          </Route>
        );
      })}

      {publicRoutes.map((publicRoute) => {
        if (publicRoute.children) {
          const Children = () => {
            return (
              <Routes>
                {publicRoute?.children?.map((child, index) => {
                  return (
                    <Route
                      path={child.path}
                      key={index}
                      index={child.index}
                      element={child.element}
                    />
                  );
                })}
              </Routes>
            );
          };
          return (
            <Route
              key={Math.random()}
              path={publicRoute.path}
              element={<Children />}
            />
          );
        }

        return (
          <Route
            key={Math.random()}
            path={publicRoute.path}
            element={publicRoute.element}
          />
        );
      })}
    </Routes>
  );
};

export default Routing;
